// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__2MheV","buttons":"Footer_buttons__2ObTr"};